// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-about-us-tsx": () => import("./../../../src/pages/about-us.tsx" /* webpackChunkName: "component---src-pages-about-us-tsx" */),
  "component---src-pages-contact-us-tsx": () => import("./../../../src/pages/contact-us.tsx" /* webpackChunkName: "component---src-pages-contact-us-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-products-asthmagram-tsx": () => import("./../../../src/pages/products/asthmagram.tsx" /* webpackChunkName: "component---src-pages-products-asthmagram-tsx" */),
  "component---src-pages-products-bluebox-tsx": () => import("./../../../src/pages/products/bluebox.tsx" /* webpackChunkName: "component---src-pages-products-bluebox-tsx" */)
}

